/**
 *
 * 套餐选择组件
 */

import React, {
    forwardRef,
    useImperativeHandle,
    useMemo,
    useState,
} from "react";
import stl from "./packageSelect.module.scss";
import { gaLensPackageEvent } from "@/src/utils/gtagEvents";
import {
    usePackageInfoContext,
    useProductDetailsContext,
    useRateContext,
} from "@/src/provider";
import classnames from "classnames";
import {
    FmButton,
    FmDrawer as FmUIDrawer,
    FmIcon,
    FmRadio,
} from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";

interface Props {}

const RenderPackageItem: React.FC<any> = (props) => {
    const { t } = useTranslation(["productDetail", "common"]);
    const [getPrice] = useRateContext((state) => [state.getPrice]);
    const [isBlue, usage, active_package] = usePackageInfoContext((state) => [
        state.isBlue,
        state.usage,
        state.active_package,
    ]);
    let name = props.name;
    if (name && name.length > 35) {
        name = name.slice(0, 35) + "...";
    }

    let disable = false;
    if (isBlue && usage.name === "no-pre") {
        const option = props.options;
        if (option && option["no-pre"] == 0) {
            disable = true;
        }
    }
    return (
        <>
            <style jsx>{`
                .package-price {
                    font-family: var(--font-montserrat-medium);
                    font-size: 0.28rem;
                    color: #333;
                    margin-left: 0.01rem;
                }
                .package-free {
                    text-transform: Uppercase;
                }
            `}</style>
            <div
                className={classnames("default_layout")}
                style={{ margin: "0.1rem 0", justifyContent: "flex-start" }}
            >
                <FmRadio
                    dataSource={[
                        {
                            label:
                                name === "Customize"
                                    ? t("productDetail:PackageInfo.Customize")
                                    : name,
                            value: props.package_id,
                        },
                    ]}
                    onChange={(e, value) => {
                        !disable && props.packageSelect(value);
                    }}
                    // disabled={disable}
                    value={active_package[0].package_id}
                />
                {props.price ? (
                    <span
                        className={stl["package-price"]}
                        style={{ fontSize: "0.28rem", marginLeft: "0.1rem" }}
                        dangerouslySetInnerHTML={{
                            __html: `+${getPrice(props.price)}`,
                        }}
                    />
                ) : (
                    props.price === 0 && (
                        <span
                            style={{
                                fontSize: "0.28rem",
                                marginLeft: "0.1rem",
                            }}
                            className="package-price package-free"
                        >
                            {t("common:BlueRay.Free")}
                        </span>
                    )
                )}
                {!props.ishideQus && (
                    <FmButton
                        onClick={() => {
                            props.packageDetailsView(props);
                        }}
                    >
                        <FmIcon
                            icon="icon--FAQ"
                            style={{
                                fontSize: "0.4rem",
                                marginLeft: "0.1rem",
                            }}
                        />
                    </FmButton>
                )}
            </div>
        </>
    );
};

const PackageSelect = forwardRef(function PackageSelect(props: Props, ref) {
    useImperativeHandle(ref, () => ({}));
    const [isBlue] = usePackageInfoContext((state) => [state.isBlue]);
    const [isShowPackageDetail, setIsShowPackageDetail] = useState(false); //是否展示套餐详情弹窗
    const [isShowAniText, setIsShowAniText] = useState(false); //是否展示套餐详情弹窗

    const [selectNotice, setSelectNotice] = useState(false);
    const [productDetail] = useProductDetailsContext((state) => [
        state.productDetail,
    ]);
    const { t } = useTranslation("productDetail");

    const [getPrice] = useRateContext((state) => [state.getPrice]);
    const [
        isDriving,
        usage,
        usages,
        packageList,
        active_package,
        packageInfoIsPackage,
        selectPackage,
        selectUsage,
    ] = usePackageInfoContext((state) => [
        state.isDriving,
        state.usage,
        state.usages,
        state.packageList,
        state.active_package,
        state.isPackage,
        state.selectPackage,
        state.selectUsage,
    ]);
    const isPackage = useMemo(() => {
        return packageInfoIsPackage && productDetail.meedPackage;
    }, [packageInfoIsPackage, productDetail.meedPackage]);

    //选中的套餐详情数据
    const [packageDetail, setPackageDetail] = useState<{
        name: string;
        package_speciality: Record<string, any>[];
        package_original_price: number;
        price: number;
    }>({
        name: "",
        package_speciality: [],
        package_original_price: 0,
        price: 0,
    });
    const [activePackageId, setActivePackageId] = useState(-1);

    //选择用途
    const usageSelect = (tempUsage: any) => {
        if (usage.name === tempUsage.name) {
            selectUsage({});
            setSelectNotice(false);
        } else {
            selectUsage(tempUsage);
            setSelectNotice(false);
        }
    };

    //选择套餐
    const packageSelect = (active_package: any) => {
        if (activePackageId === active_package.package_id) {
            selectPackage({});
            setActivePackageId(-1);
        } else {
            selectPackage(active_package);
            setActivePackageId(active_package.package_id);

            //无处方特殊套餐联动
            if (isDriving && usage.name === "reading") {
                selectUsage({});
            }
        }
    };

    const toggerModal = () => {
        // if (!isShowPackageDetail) {
        //     this.style = document.createElement("style");
        //     this.style.innerHTML =
        //         ".am-modal-wrap{background-color: rgba(0, 0, 0, .5)} .am-modal-mask{background-color: rgba(0, 0, 0, 0)}";
        //     document.head.appendChild(this.style);
        // } else {
        //     this.style && document.head.removeChild(this.style);
        // }

        setIsShowPackageDetail((prev) => !prev);
    };

    const packageDetailsView = (packageItem: any) => {
        setPackageDetail((prev) => {
            toggerModal();
            return packageItem;
        });
        gaLensPackageEvent("question-package", packageItem.name);
    };

    const selecUsagetNotice = () => {
        setIsShowAniText(true);

        setSelectNotice(true);

        setTimeout(() => {
            setIsShowAniText(false);
        }, 1000);
    };

    const { name, package_speciality, package_original_price, price } =
        packageDetail;
    return (
        !isPackage && (
            <div className={stl["select-package-list-container"]}>
                <p className={stl["select-title"]} style={{ marginTop: 0 }}>
                    {t("productDetail:PackageInfo.SelectLensPackage")}:
                </p>
                <div className={stl["select-list"]}>
                    {packageList.map((item: any, index: number) => (
                        <RenderPackageItem
                            {...item}
                            key={index}
                            packageDetailsView={packageDetailsView}
                            packageSelect={packageSelect}
                        />
                    ))}
                </div>
                <p
                    className={`select-title ${isShowAniText ? "shakeX" : ""}`}
                    style={{
                        color: selectNotice ? "#F69000" : "#333",
                    }}
                >
                    {t("productDetail:PackageInfo.SelectGlassesType")}:
                </p>

                <div className="select-list select-list-flex">
                    {usages.map((item: any, index: number) => {
                        const options = active_package.options
                            ? active_package.options
                            : {};

                        let is_disable = false;
                        if (isDriving && item.name === "reading") {
                            is_disable = true;
                        }
                        if (isBlue) {
                            is_disable = options[item.name] == 0;
                        }
                        return (
                            <div
                                onClick={() => {
                                    !is_disable && usageSelect(item);
                                }}
                                key={index}
                            >
                                <FmRadio
                                    dataSource={[
                                        {
                                            label: t(
                                                `productDetail:${item.name}`,
                                            ),
                                            value: item.name,
                                        },
                                    ]}
                                    value={usage.name}
                                    // disable={is_disable}
                                />
                            </div>
                        );
                    })}
                </div>
                {selectNotice && (
                    <p className={stl["pack-err-text"]}>
                        {t("productDetail:PackageInfo.PleaseSelectGlasses")}
                    </p>
                )}
                {/* TODO: 暂未复现 */}
                <FmUIDrawer
                    closeable
                    // transparent
                    className={stl["package-detail-contaner"]}
                    open={isShowPackageDetail}
                    onClose={toggerModal}
                    fullHeight
                    // headerChildren
                >
                    <div className={stl["package-detail-modal"]}>
                        {name === "Customize" ? (
                            <p
                                style={{
                                    padding: "0.2rem 0.4rem",
                                    color: "#333",
                                }}
                            >
                                {isBlue
                                    ? t(
                                          "productDetail:PackageInfo.CustomizeTextBlue",
                                      )
                                    : t(
                                          "productDetail:PackageInfo.CustomizeText",
                                      )}
                            </p>
                        ) : (
                            <>
                                <p className={stl["title"]}>{name}</p>
                                <FmRadio
                                    dataSource={package_speciality.map(
                                        (item: any) => {
                                            return {
                                                label: item.name,
                                                value: item.name,
                                            };
                                        },
                                    )}
                                    value={package_speciality[0].name}
                                />
                                {package_original_price - price > 0 && (
                                    <p
                                        className={stl["price-text"]}
                                        dangerouslySetInnerHTML={{
                                            __html: `${t("productDetail:PackageInfo.Save")} ${getPrice(package_original_price - price)} ${t("productDetail:PackageInfo.ComparedWithCustomization")}`,
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </FmUIDrawer>
            </div>
        )
    );
});

export default PackageSelect;
